import { UserRole } from '../../components/interfaces/account/socialComponent';
import { fromStringToTicks } from '../../utils/dateUtils';

export class SessionContextDto {
  bearerToken = '';
  firstName = '';
  surname = '';
  image = '';
  expiredAt: number = fromStringToTicks(new Date().toString());
  isVerified = false;
  emailVerified = false;
  telephoneVerified = false;
  registeredWith: number = 0;
  userRoles: UserRole[] = [];
  id: number = 0;
  hasFinancialDocument = false;
  hasIdentityCard = false;
  documents: any;
  isPremiumAccount: boolean = false;
  isPremiumFromSubscription: boolean = false;
  isSubscriptionDeletedByUser: boolean = false;
  hasValidPaidAdvice: boolean = false;
  premiumUntilUtc: number = fromStringToTicks(new Date().toString());

  constructor(anotherObject: SessionContextDto | null = null) {
    Object.assign(this, anotherObject);
  }

  public isLogged() {
    return this.bearerToken !== '';
  }

  public isPremiumActive() {
    const currentTime = fromStringToTicks(new Date().toString());
    return this.isPremiumAccount && this.premiumUntilUtc > currentTime;
  }

  public setPremium(expireDate: number) {
    this.isPremiumAccount = true;
    this.premiumUntilUtc = expireDate;
  }

  public setPremiumFromSubscription(bol: boolean) {
    this.isPremiumFromSubscription = bol;
  }

  public cancelPremium() {
    this.isPremiumAccount = false;
    this.isPremiumFromSubscription = false;
    this.premiumUntilUtc = fromStringToTicks(new Date().toString());
  }
}
